import React from "react";
import Autocomplete, { AutocompleteProps, autocompleteClasses } from "@mui/material/Autocomplete";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import WcTextField from "../WcTextfield/WcTextField";

export type WcAutoCompleteProps<T> = AutocompleteProps<T, boolean | undefined, boolean | undefined, boolean | undefined>;
export const WcAutoComplete = <T,>(params: WcAutoCompleteProps<T>) => (
  <Autocomplete
    id="WcAutoComplete"
    renderInput={(InputParams) => <WcTextField {...InputParams} label="AutoCompleteInputLabel" />}
    // renderOption={(props, option, state, ownerState) => (
    //   <Box
    //     sx={{
    //       borderRadius: "8px",
    //       margin: "5px",
    //       [`&.${autocompleteClasses.option}`]: {
    //         padding: "8px",
    //       },
    //     }}
    //     component="li"
    //     {...props}
    //   >
    //     {ownerState.getOptionLabel?.(option)}
    //   </Box>
    // )}
    // PaperComponent={(props) => (
    //   <Paper
    //     variant="elevation"
    //     sx={{
    //       // backgroundColor: theme.appColors.surfaceContainerHighest,
    //       fontSize: "25px",
    //     }}
    //     {...props}
    //   />
    // )}
    forcePopupIcon={params.disabled ? false : true}
    {...params}
  />
);

export default WcAutoComplete;
